module.exports = __webpack_public_path__ + "img/brands-harrys-bg-4.png?702d43280f561531d70f1c0f62c701b7";